import React, { useContext, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import Logo from "../assets/images/logo.png";
import logout from "../assets/images/logout.png";
import { Token } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { PreferencesContext } from "../PreferenceContext";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { defaultContext, Context } from "../service/models/Context";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axios from "axios";
import ContactUsMenu from "./ContactUsMenu";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const Navbar: React.FC = () => {
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  // const { token } = useParams();
  // const token = userContext?.token;
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [contactOpen, setContactOpen] = useState(false);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignin = () => {
    navigate("/sign-in");
    handleClose();
  };

  const handleLogout = () => {
    updateUserContext(defaultContext);
    localStorage.clear();
    delete axios.defaults.headers.common["Authorization"];
    navigate("/sign-in");
    handleClose();
  };

  const handleContact = () => {
    setContactOpen(true);
    handleClose();
  };

  const handleContactClose = () => {
    setContactOpen(false);
  };
  return (
    <>
      <AppBar
        position="static"
        sx={{ backgroundColor: "#4C0808", boxShadow: "none" }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            minHeight: "40px !important",
            marginTop: "2px",
          }}
        >
          <Box display="flex" alignItems="center">
            <img src={Logo} alt="Logo" style={{ height: 38 }} />
          </Box>

          <Box display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
            <Box
              onClick={handleClick}
              sx={{
                fontWeight: 400,
                fontSize: "16px",
                marginRight: "6px !important",
              }}
            >
              {userContext?.firstName}
            </Box>
            {!userContext?.userId && (
              <Typography
                variant="body2"
                sx={{
                  marginLeft: "16px",
                  marginRight: "6px !important",
                  color: "white",
                  fontWeight: 400,
                  fontSize: "12px",
                  cursor: "pointer",
                }}
                onClick={handleClick}
              >
                Menu
              </Typography>
            )}
            <IconButton
              onClick={handleClick}
              disableRipple
              disableFocusRipple
              sx={{
                padding: "0 !important",
                borderRadius: 0,
                // marginLeft: "-15px",
                color: "white",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <KeyboardArrowDownIcon sx={{ height: "20px", width: "20px" }} />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              // anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              // transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              {userContext.userId ? (
                <MenuItem onClick={handleLogout}>
                  Log out
                  <img
                    src={logout}
                    alt="Edit profile"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginLeft: "6px",
                    }}
                  />
                </MenuItem>
              ) : (
                <MenuItem onClick={handleSignin}>
                  Sign in
                  <img
                    src={logout}
                    alt="Edit profile"
                    style={{ width: "20px", height: "20px", marginLeft: "6px" }}
                  />
                </MenuItem>
              )}
              <MenuItem onClick={handleContact}>Contact Us</MenuItem>
              {/* {userContext.userId && (
                <MenuItem onClick={handleLogout}>
                  Log out
                  <img
                    src={logout}
                    alt="Edit profile"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginLeft: "6px",
                    }}
                  />
                </MenuItem>
              )}
              {!userContext?.userId && (
                <MenuItem onClick={handleSignin}>
                  Sign in
                  <img
                    src={logout}
                    alt="Edit profile"
                    style={{ width: "20px", height: "20px", marginLeft: "6px" }}
                  />
                </MenuItem>
              )} */}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      {/* Contact Us Dialog */}

      <Dialog
        open={contactOpen}
        onClose={handleContactClose}
        TransitionComponent={undefined} // removes transition
        BackdropProps={{ transitionDuration: 0 }}
        PaperProps={{
          sx: {
            boxShadow:"none",
            borderRadius: "10px", // 👈 apply radius here
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            borderRadius: "8px",
            // padding: "24px 40px",
            "& .MuiTypography-root": {
              fontFamily: "Poppins, sans-serif",
            },
          }}
        >
          <IconButton
            onClick={handleContactClose}
            disableRipple
            disableFocusRipple
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              p: "0 !important",
              borderRadius: "8px",
              color: "black",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.05)",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          {/* Email text */}
          <Typography
            variant="body1"
            sx={{
              fontSize: "18px",
              fontWeight: 500,
              marginTop: "20px",
              marginBottom: "20px",
              padding: "0px 10px 0px 10px",
            }}
          >
            hello@stakeholdermaps.com
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Navbar;
